function handleUnsupportedBrowsers(): void {
  // documentMode is only available in Internet Explorer
  if (window.document.documentMode == undefined) {
    // It isn't IE so we probably support it and do nothing.
    return;
  }

  jQuery.ajax("/api/browser-not-supported").done(function (data) {
    jQuery("#main").html(data);
  });
}

handleUnsupportedBrowsers();
